import { TabStack } from '@/components/TabStack';

export default function InquiryTabLayout() {
  return <TabStack tab="inquiry" />;
}
